import React from 'react'
import HomeNavbar from './HomeNavbar'
import Footer from './Footer'

function RiskDisclosurePolicy() {
  return (
    <>
      <HomeNavbar />

      <div className="bg-white w-full py-20 text-center font-oswald mt-10">
        <div className="flex items-center justify-center">
          <p
            style={{ backgroundColor: "#F5A623" }}
            className="rounded-full py-2 px-6 font-bold text-bgBlue"
          >
            R&D
          </p>
        </div>

        <br />

        <h2 className="text-3xl font-bold text-gray-900">
         Risk Disclosure & <span className="text-secondary">No Earnings Guarantee</span>
        </h2>

        <div className="lg:w-3/4 m-auto shadow-xl mt-10">
          <div className="text-bgBlue p-8 text-start">

            <h1 className="text-4xl font-bold mb-4">Risk Disclosure Policy</h1>
            <p className="mb-4">Effective Date: 30 November 2025</p>
            <p className="mb-4">Platform Name: Adhyayi</p>
            <p className="mb-4">Owned & Operated By: AKRYPT IT SOLUTIONS PRIVATE LIMITED</p>
            <p className="mb-4">Jurisdiction: India</p>

         {/* 1 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    EDUCATIONAL PLATFORM NOTICE
  </h2>

  <p>
    Adhyayi is a skill-based educational platform designed to support learning,
    practice, assessment, performance tracking, and reward-based engagement.
  </p>

  <p className="mt-3">The Platform is not:</p>

  <ul className="list-disc ml-6 mt-2">
    <li>A gambling service;</li>
    <li>A betting or wagering platform;</li>
    <li>A lottery or chance-based game;</li>
    <li>An investment product;</li>
    <li>A fixed-income or profit-generating scheme.</li>
  </ul>

  <p className="mt-3">
    Any rewards, rankings, benefits, or incentives available through the
    Platform are based on educational participation and performance criteria.
  </p>
</section>

{/* 2 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    NO GUARANTEED EARNINGS
  </h2>

  <p>Adhyayi does not guarantee:</p>

  <ul className="list-disc ml-6 mt-2">
    <li>Income;</li>
    <li>Earnings;</li>
    <li>Profits;</li>
    <li>Employment;</li>
    <li>Financial returns;</li>
    <li>Contest winnings; or</li>
    <li>Any specific monetary outcome.</li>
  </ul>

  <p className="mt-3">
    Any rewards, coins, benefits, or winnings earned through the Platform
    depend on various factors including :
  </p>
<ul className="list-disc ml-6 mt-2">
    <li>User knowledge,</li>
    <li>Accuracy,</li>
    <li>Preparation level,</li>
    <li>Speed,</li>
    <li>Participation,</li>
    <li>Competition level,</li>
    <li>Compliance with applicable rules.</li>
  </ul>
  <p className="mt-2">
    Participation on the Platform does not guarantee that a user will
    receive rewards or earn money.
  </p>
</section>

{/* 3 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    PERFORMANCE-BASED OUTCOMES
  </h2>

  <p>
    Contest scores, rankings, achievements, and rewards are determined
    through performance-based evaluation mechanisms.
  </p>

  <p className="mt-2">
    Results may vary from user to user based on individual skill,
    preparation, consistency, and performance.
  </p>

  <p className="mt-2">
   Users acknowledge that poor performance may result in lower rankings,
    reduced rewards, or no rewards at all.
  </p>
</section>

{/* 4 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    CONTEST PARTICIPATION RISKS
  </h2>

  <p>
    Certain contests or activities may require an entry fee
    or participation fee.
  </p>

  <p className="mt-3">
    Users acknowledge and agree that:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Participation does not guarantee winning.</li>
    <li>Prize pools may be limited.</li>
    <li>Rankings depend on comparative performance.</li>
    <li>Not all participants will receive rewards.</li>
    <li>
      Entry fees may be non-refundable except where expressly provided
      under applicable policies.
    </li>
  </ul>

  <p className="mt-3">
    Users participate in contests at their own discretion and risk.
  </p>
</section>

{/* 5 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    COINS, REWARDS & VIRTUAL UNITS
  </h2>
  <p className="mt-3">Coins, credits, reward points, wallet balances, or similar virtual units available on Adhyayi:</p>

  <ul className="list-disc ml-6 mt-3">
    <li>Are not legal tender;</li>
    <li>Are not cryptocurrency;</li>
    <li>Are not securities or investment products;</li>
    <li>Do not represent ownership rights;</li>
    <li>Have no guaranteed monetary value outside the Platform.</li>
  </ul>

  <p className="mt-3">
    The Platform reserves the right to modify reward structures,
    earning mechanisms, redemption criteria, coin ratios,
    or withdrawal requirements in accordance with business,
    legal, operational, or compliance requirements.
  </p>
</section>

{/* 6 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    WITHDRAWAL & VERIFICATION RISKS
  </h2>

  <p>
    Users may be required to complete identity verification,
    KYC procedures, account verification, or compliance checks
    before withdrawals are processed.
  </p>
  <p className="mt-3">
    Withdrawals may be delayed, restricted, suspended, or rejected in cases including but not limited to:
  </p>

  <ul className="list-disc ml-6 mt-3">
    <li>Incomplete verification;</li>
    <li>Incorrect account information;</li>
    <li>Suspected fraud;</li>
    <li>Policy violations;</li>
    <li>Regulatory compliance requirements.</li>
  </ul>
</section>

{/* 7 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    TECHNICAL RISKS
  </h2>

      <p className='mt-3'>Users acknowledge that online services may be affected by circumstances beyond the Platform's control, including:</p>
  <ul className="list-disc ml-6 mt-3">
    <li>Internet connectivity issues;</li>
    <li>Device failures;</li>
    <li>Software incompatibilities;</li>
    <li>Server interruptions;</li>
    <li>Maintenance activities;</li>
    <li>Security incidents;</li>
    <li>Force majeure events.</li>
  </ul>

  <p className="mt-3">
    Adhyayi does not guarantee uninterrupted,
    error-free, or continuous availability of services.
  </p>
</section>

{/* 8 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    POLICY & PLATFORM CHANGES
  </h2>

  <p>
    Adhyayi reserves the right to modify, update,
    suspend, replace, or discontinue:
  </p>

  <ul className="list-disc ml-6 mt-2">
    <li>Contest formats;</li>
    <li>Scoring methodologies;</li>
    <li>Reward structures;</li>
    <li>Coin conversion mechanisms;</li>
    <li>Withdrawal policies;</li>
    <li>Platform features;</li>
    <li>Operational procedures.</li>
  </ul>
  <p className='mt-3'>Any such changes shall be implemented in accordance with applicable laws and platform requirements.</p>
</section>

{/* 9 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    USER RESPONSIBILITY
  </h2>

<p className='mt-3'>Users are solely responsible for:</p>
  <ul className="list-disc ml-6 mt-3">
    <li>Their participation decisions;</li>
    <li>Their educational preparation;</li>
    <li>Their financial decisions;</li>
    <li>Their understanding of platform rules and risks.</li>
  </ul>

  <p className="mt-3">
    Users should not rely on the Platform as a source of guaranteed income,
    employment, investment returns, or financial security.
  </p>
</section>

{/* 10 */}

<section className="mb-6">
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    ACCEPTANCE OF RISK
  </h2>

  <p className='mt-3'>By registering, accessing, or using Adhyayi, users acknowledge and agree that:</p>

  <ul className="list-disc ml-6 mt-3">
    <li>They have read and understood this Risk Disclosure;</li>
    <li>They voluntarily accept participation risks;</li>
    <li>Rewards and outcomes are performance-dependent;</li>
    <li>Earning opportunities are not guaranteed.</li>
  </ul>

  <p className="mt-3">
    If a user does not agree with these risks,
    the Platform should not be used.
  </p>
</section>

{/* 11 */}

<section>
  <h2 className="flex items-center text-2xl font-semibold mb-2">
    <span className="text-secondary text-5xl mr-2">•</span>
    IMPORTANT NOTICE
  </h2>

  <p>Learning is an opportunity.</p>
  <p>Rewards are performance-based.</p>

  <p className="mt-2">
    Earnings, winnings, or financial benefits—where available—
    are possibilities, not promises.
  </p>

  <p className="mt-2">
    Adhyayi's primary objective is education,
    skill development, learning engagement,
    and fair competition.
  </p>
</section>



          </div>
        </div>
      </div>

      <Footer />
    </>
  )
}

export default RiskDisclosurePolicy;